import { ICellRendererParams } from "ag-grid-community";
import React, { Component } from "react";

interface Props {
  [key: string]: any;
}

export function classHOC(WrapperComponent: any) {
  return class ClassWrapper extends Component<Props & Partial<ICellRendererParams>> {
    constructor(props: Props & Partial<ICellRendererParams>) {
      super(props);
    }
    public refresh() {
      return false;
    }

    public render() {
      return <WrapperComponent {...this.props} />;
    }
  };
}
